<template>
  <div
    class="c-product-info__size-filter"
    :class="[
      'l-flex',
      'l-flex--justify-between',
      'u-margin-bottom-small'
    ]"
  >
    <h2
      v-if="isGiftCard"
      class="t-heading-7"
    >
      VALUE:
    </h2>
    <h2
      v-else
      class="t-heading-7"
    >
      {{ ringOrBracelet }} SIZE:
    </h2>
    <!-- <a
      v-if="ringOrBracelet === 'BRACELET'"
      class="t-link t-link--accent"
      :href="braceletSizeGuideUrl"
      target="_blank"
    >Bracelet Size Guide</a> -->
    <dropdown
      v-if="dropdown && !isGiftCard"
      v-model="selectedSize"
      :options="ringSizes"
      placeholder="Select Size"
      class="c-product-info__size-filter__dropdown"
    />
    <div v-if="sizeGuideModal">
      <btn
        v-if="ringOrBracelet === 'BRACELET'"
        type="link"
        custom-color="#e9b419"
        @click="toggleSizeGuideModal($event)"
      >
        Bracelet Size Guide
      </btn>
      <btn
        v-else
        type="link"
        custom-color="#e9b419"
        @click="toggleSizeGuideModal($event)"
      >
        Find My Ring Size
      </btn>
    </div>
    <div v-else>
      <nuxt-link
        v-if="ringOrBracelet === 'BRACELET'"
        to="/pages/ring-size-guide#find-your-bracelet-size"
        class="t-link t-link--accent"
        target="_blank"
      >
        Bracelet Size Guide
      </nuxt-link>
      <nuxt-link
        v-else
        :to="ringSizeGuideUrl"
        class="t-link t-link--accent"
        target="_blank"
      >
        Find My Ring Size
      </nuxt-link>
    </div>
    <div v-if="!dropdown || isGiftCard">
      <circle-select
        v-if="isGiftCard"
        v-model="selectedSize"
        :options="giftCardAmounts"
        placeholder="Select Amount"
        class="c-product-info__size-filter__circle-select"
      />
      <circle-select
        v-else-if="ringSizes && ringSizes.length"
        v-model="selectedSize"
        :options="ringSizes"
        :allow-disable="false"
        placeholder="Select Size"
        class="c-product-info__size-filter__circle-select"
      />
    </div>
  </div>
</template>
<script>
import CircleSelect from '../dropdown/CircleSelect'
import get from 'lodash/get'
import StockDataMixin from './StockDataMixin'
import Dropdown from '../dropdown/Dropdown.vue'
import Btn from "@/components/button/Btn"

export default {
  components: {
    CircleSelect,
    Dropdown,
    Btn
  },
  mixins: [
    StockDataMixin
  ],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: [Number, String],
      default: null
    },
    isGiftCard: {
      type: Boolean,
      default: false
    },
    dropdown: {
      type: Boolean,
      default: false
    },
    sizeGuideModal: {
      type: Boolean,
      default: false
    },
    variantInStock: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      braceletSizeGuideUrl: [
        'https://cdn.shopify.com/s',
        '/files/1/0018/8612/6193/files/bracelet-size-guide-updated-size.pdf',
        '?v=1601584319'
      ].join(''),
    }
  },
  computed: {
    selectedSize: {
      get() {
        const size = this.size
        return size || null
      },
      set(value) {
        this.$emit('update:size', value)
      }
    },
    ringOrBracelet() {
      const product = this.product;
      //console.log(product.title)
      let result = "RING";
      if (
        product &&
          product.productType &&
          product.productType.includes("Bracelet")
      ) {
        result = "BRACELET";
      }
      return result;
    },
    ringSizeGuideUrl() {
      if (this.product.handle.includes('drtv')) {
        return '/pages/drtv-ring-size-guide'
      } else {
        return '/pages/ring-size-guide'
      }
    },
    ringSizes() {
      const product = this.product
      const stockData = this.variantInStock
      return this.productStockOptions(product, stockData)
    },
    giftCardAmounts() {
      const product = this.product
      const isGiftCard = this.isGiftCard
      if (isGiftCard) {
        return product.variants.map(
          (variant) => get(variant, 'selectedOptions[0].value')
        )
      }
      return null
    }
  },
  methods: {
    toggleSizeGuideModal() {
      this.$emit("modal:open")
    }
  },
}
</script>
<style lang="scss" scoped>
.c-product-info__size-filter {
  padding: rem(20px) 0;
  @include themify($themes) {
    border-top: $border themed("foreground", "section-border");
  }
  &__circle-select {
    width: 100%;
  }
  &__dropdown {
    width: rem(140px);
  }
}
</style>
